import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CASE_STUDIES } from "@/data/caseStudies";

export default function Work() {
  return (
    <div className="pt-40 md:pt-56 pb-24 md:pb-40" data-testid="work-page">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-stone-muted">
          [ Vol. II ] · Index of work
        </p>
        <h1 className="mt-8 font-display text-6xl md:text-[11rem] leading-[0.86] tracking-tightest text-charcoal">
          The <em className="italic text-stone-muted">work</em>.
        </h1>
        <p className="mt-8 max-w-xl font-serif italic text-lg leading-relaxed text-charcoal/70">
          Six selected engagements from the last eighteen months. Each shipped, each measured, each still
          in the field.
        </p>
      </div>

      {/* Index list */}
      <div className="mt-24 border-t border-charcoal/25 mx-auto max-w-[1600px] px-6 md:px-12">
        {CASE_STUDIES.map((c, i) => (
          <motion.div
            key={c.slug}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.04, ease: [0.22, 1, 0.36, 1] }}
            className="border-b border-charcoal/25"
          >
            <Link
              to={`/work/${c.slug}`}
              className="group grid grid-cols-12 gap-4 items-center py-6 md:py-10"
              data-testid={`work-index-${c.slug}`}
            >
              <span className="col-span-2 md:col-span-1 font-mono text-[11px] tracking-[0.22em] text-stone-muted">
                {c.index}
              </span>
              <span className="col-span-10 md:col-span-4 font-display text-3xl md:text-5xl tracking-tightest leading-none group-hover:italic transition-all duration-500">
                {c.title}
              </span>
              <span className="col-span-6 md:col-span-3 font-mono text-[11px] uppercase tracking-[0.22em] text-stone-muted">
                {c.category}
              </span>
              <span className="col-span-4 md:col-span-2 font-mono text-[11px] uppercase tracking-[0.22em] text-stone-muted">
                {c.sector}
              </span>
              <span className="col-span-2 md:col-span-2 text-right font-mono text-[11px] uppercase tracking-[0.22em] text-stone-muted">
                {c.year} →
              </span>
            </Link>
          </motion.div>
        ))}
      </div>

      {/* Visual gallery */}
      <div className="mt-32 mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-12 gap-8">
        {CASE_STUDIES.map((c, i) => (
          <motion.div
            key={c.slug}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={
              i % 6 === 0
                ? "col-span-12 md:col-span-8"
                : i % 6 === 1
                ? "col-span-12 md:col-span-4 md:mt-32"
                : i % 6 === 2
                ? "col-span-12 md:col-span-5"
                : i % 6 === 3
                ? "col-span-12 md:col-span-6 md:col-start-7"
                : i % 6 === 4
                ? "col-span-12 md:col-span-7"
                : "col-span-12 md:col-span-4 md:col-start-9 md:-mt-40"
            }
          >
            <Link to={`/work/${c.slug}`} className="block group" data-testid={`work-gallery-${c.slug}`}>
              <div className={`spotlight frame ${c.aspect} bg-cream`}>
                <img src={c.cover} alt={c.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="mt-4 flex justify-between items-baseline">
                <h3 className="font-display text-2xl tracking-tightest">{c.title}</h3>
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-stone-muted">{c.location}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
